import { Model } from '@/models/Model';
import { SubCategory } from './SubCategory';

export class Category extends Model
{
  protected $name: string = 'Category';
  protected $endpoint: string = '/categories';
  protected $fillable: string[] = ['name', 'sub_categories', 'short_name'];

  public name?: string;
  public id!: string;
  public short_name?: string;
  public sub_categories?: SubCategory[];
  public parent_id?: string;

  protected static instance?: Category;
  public static getInstance(instance: Category) {
    if (! this.instance) {
      this.instance = instance;
    }

    return this.instance;
  }
}
